import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TextInput } from 'ui_elements/TextInput/TextInput'

const StyledInput = styled(TextInput)`
  width: 100%;
  text-align: right;
  padding-right: 3px;

  &:focus {
    border: 1px solid ${props => props.theme.colors.primary};
  }
`

export const EditableNumberCell = ({ value, onChange }) => {
  return (
    <StyledInput
      value={value}
      onChange={e => onChange(e.target.value)}
      type="number"
    />
  )
}

EditableNumberCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired
}
